import { useRef } from 'react';
import type { FC } from 'react';
import { isUiModificationsSupportEnabled } from '@helpCenter/feature-flags';
import { useRouter } from 'react-resource-router';
import getUFORouteName from '@atlaskit/react-ufo/route-name';
import traceUFOPageLoad from '@atlaskit/react-ufo/trace-pageload';
import traceUFOTransition from '@atlaskit/react-ufo/trace-transition';
import { ExperienceName } from '@atlassian/help-center-common-component/constants';
import { startScreenTTIWithUIModifications } from '@atlassian/jsm-ui-modifications-view-request-create/src/common/utils/performance-analytics/request-create';

export const UFOWatcher: FC = () => {
    const isInitial = useRef(true);
    const [routerState] = useRouter();
    const route = routerState.route;
    const match = routerState.match;

    let ufoName = getUFORouteName(route).toLowerCase();

    if ('getUFONameBasedOnRouteMatch' in route && route.getUFONameBasedOnRouteMatch instanceof Function) {
        ufoName = route.getUFONameBasedOnRouteMatch(match) as string;
    }

    const lastUFOName = useRef(ufoName);
    if (ufoName) {
        if (isUiModificationsSupportEnabled() && ufoName === ExperienceName.REQUEST_CREATE) {
            startScreenTTIWithUIModifications();
        }
        if (isInitial.current) {
            traceUFOPageLoad(ufoName);
            isInitial.current = false;
        }
        if (lastUFOName.current !== ufoName && !isInitial.current) {
            lastUFOName.current = ufoName;
            traceUFOTransition(ufoName);
        }
    }
    return null;
};
